import { Component, ChangeDetectorRef } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LearningResourceFeeService } from '../../../../services/learningresourcefee.service';
import { Subscription } from 'rxjs';
import { RateModelDto } from '../../../../models/ratemodeldto';
import { TaxesService } from '../../../../services/taxes.service';
import { VatPatternDto } from '../../../../models/vatPattern/vatpatterndto';
import { LearningResourceFeePriceService } from '../../../../services/learningresourcefeeprices.service';
import { TranslateService, TranslatePipe, TranslateDirective, LangChangeEvent } from "@ngx-translate/core";
import { VatPatternService } from '../../../../services/vatpattern.service';
import { LearningResourceFeeDto } from '../../../../models/learningresourcefeedto';
import { LearningResourceFeePriceDto } from '../../../../models/learningresourcefeepricedto';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { ErrorModalComponent } from '../../../../components/error-modal/error-modal.component';
import { LearningResourceFeeRequest } from '../../../../models/learningFeeResourceRequest';
import { LearningResourceFeeResponse } from '../../../../models/learningFeeResourceResponse';
import { LearningResourceFeePriceRequest } from '../../../../models/learningFeePriceRequest';
import { LearningResourceFeePriceResponse } from '../../../../models/learningFeePriceResponse';
import { RateModelRequest } from '../../../../models/rateModelRequest';
import { RateModelResponse } from '../../../../models/rateModelResponse';
import { VatPatternRequest } from '../../../../models/vatPattern/vatPatternRequest';
import { VatPatternResponse } from '../../../../models/vatPattern/vatPatternResponse';
import { SharedService } from '../../../../services/shared.service';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { GeneralDiscountCatalogRequest, GeneralDiscountCatalogResponse, IdOwnRateDiscountDto, IdOwnRateDiscountDtoRequest, IdOwnRateDiscountDtoResponse } from '../../../../models/discountGeneralCatalog/OwnRateDiscount.modelDto';
import { GeneralDiscountCatalogDto } from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountService } from '../../../../services/discountService.service';
import { DiscountRateModelCatalogRequest, DiscountRateModelCatalogResponse } from '../../../../models/discountGeneralCatalog/DiscountRateModelCatalog.model';
import { re } from 'mathjs';

@Component({
  selector: 'app-learningresources',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe, TranslateDirective, PaginatorComponent, ErrorModalComponent, AlertComponentComponent],
  templateUrl: './learningresources.component.html',
  styleUrl: './learningresources.component.css'
})
export class LearningresourcesComponent {
  links: any[] = [];
  subLinks: any[] = [];

  listVatPattern: VatPatternDto[] = []; // Lista de patrones de IVA
  isModalOpen: boolean = false; // Controla la visibilidad del modal
  selectedRowId: any = null; // Variable para almacenar el ID de la fila seleccionada
  selectedMaterialPricesRowId: any = null; // Variable para almacenar el ID de la fila seleccionada
  message: Array<any> = []; // Mensaje del modal de error

  isCreate: boolean = false;
  isCreateMaterialPrices: boolean = false;
  isCreatedMaterialPrices: boolean = false;
  isCreateOwnRateDiscount: boolean = false;
  isCreatedOwnRateDiscount: boolean = false;

  isErrorOwnRateDiscount: boolean = false;
  isError: boolean = false;
  isErrorMaterialPrices: boolean = false;
  isCreated: boolean = false;
  isClone: boolean = false; // se ha producido un error

  currentLanguage: string = 'es'; // Idioma actual
  learningResourceFee: LearningResourceFeeDto = new LearningResourceFeeDto(); // Objeto para almacenar la tasa de recursos de aprendizaje
  selectedRateModel: RateModelDto = new RateModelDto(); // Modelo de tasa seleccionado
  selectedOwnRateDiscount: IdOwnRateDiscountDto = new IdOwnRateDiscountDto(); // Tasa académica seleccionada
  selectedOwnRateDiscountId: any = null; // Precio académico seleccionado

  discountRateModelRequest: DiscountRateModelCatalogRequest = new DiscountRateModelCatalogRequest();
  discountRateModelResponse: DiscountRateModelCatalogResponse = new DiscountRateModelCatalogResponse();

  createPrice = true; // Variable para determinar si se crea un nuevo precio de recurso
  modifTranslates: boolean = false; // Variable para determinar si se han modificado las traducciones
  showErrorModal: boolean = false; // Controla la visibilidad del modal de error
  errorTitle: string = ''; // Título del modal de error
  errorMessage: string = ''; // Mensaje del modal de error

  learningResourceFeeRequest: LearningResourceFeeRequest = new LearningResourceFeeRequest(); // Objeto para la solicitud de tasa de recursos de aprendizaje
  learningResourceFeeResponse: LearningResourceFeeResponse = new LearningResourceFeeResponse(); // Objeto para la respuesta de tasa de recursos de aprendizaje
  learningResourceFeePriceRequest: LearningResourceFeePriceRequest = new LearningResourceFeePriceRequest(); // Objeto para la solicitud de precio de tasa de recursos de aprendizaje
  learningResourceFeePriceResponse: LearningResourceFeePriceResponse = new LearningResourceFeePriceResponse(); // Objeto para la respuesta de precio de tasa de recursos de aprendizaje
  modelRequest: RateModelRequest = new RateModelRequest(); // Objeto para la solicitud de modelo de tasa
  modelResponse: RateModelResponse = new RateModelResponse(); // Objeto para la respuesta de modelo de tasa
  vatPatternRequest: VatPatternRequest = new VatPatternRequest(); // Objeto para la solicitud de patrón de IVA
  vatPatternResponse: VatPatternResponse = new VatPatternResponse(); // Objeto para la respuesta de patrón de IVA
  discountReponse: GeneralDiscountCatalogResponse = new GeneralDiscountCatalogResponse();
  discountRequest: GeneralDiscountCatalogRequest = new GeneralDiscountCatalogRequest();
  ownRateDiscountRequest: IdOwnRateDiscountDtoRequest = new IdOwnRateDiscountDtoRequest();
  ownRateDiscountResponse: IdOwnRateDiscountDtoResponse = new IdOwnRateDiscountDtoResponse();
  private langChangeSubscription!: Subscription;

  constructor(
    private sharedService: SharedService, // Servicio compartido para la paginación
    private routelinks: RoutelinksService, private cdr: ChangeDetectorRef, private learningResourceFeeService: LearningResourceFeeService,
    private translateService: TranslateService, private taxesService: TaxesService, private learningResourceFeePriceService: LearningResourceFeePriceService,
    private vatPatternService: VatPatternService, private discountServices: DiscountService
  ) {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en el constructor
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en ngOnInit

    this.currentLanguage = this.translateService.currentLang || 'es'; // Establece el idioma actual
  }

  formDiscount = new FormGroup({
    discountCode: new FormControl(),
    idOwnRateDiscount: new FormControl(),
    importType: new FormControl('I'),
    rateType: new FormControl('R', Validators.required),
    discountPercentage: new FormControl(),
    fixedDiscountAmount: new FormControl(),
    discountOrderNumber: new FormControl(0, Validators.required),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl(''),
    idRateModel: new FormControl(),
    idGeneralDiscountCatalog: new FormControl(),
  });

  learningResourcePriceForm = new FormGroup({
    startDate: new FormControl('', Validators.required), // Campo de fecha obligatorio
    endDate: new FormControl(''), // Campo de fecha opcional
    firstTermPayment: new FormControl(false), // Select obligatorio
    price: new FormControl('', [Validators.min(0)]), // Campo numérico obligatorio
    idVatPattern: new FormControl(), // Select opcional
  });

  learningResourceForm = new FormGroup({
    chargeShipping: new FormControl(false), // Inicializa el checkbox con un valor booleano
    typeMaterial: new FormControl('', Validators.required),
    descriptionCat: new FormControl('', Validators.required),
    descriptionCast: new FormControl('', Validators.required),
    descriptionIng: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    this.loadRateModels(true); // Carga los modelos de tasas al inicializar el componente
    this.loadVatPatterns(true); // Carga los patrones de IVA al inicializar el componente
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang; // Actualizar el idioma actual
      this.cdr.detectChanges();
      this.loadRateModels(true); // Carga los modelos de tasas al inicializar el componente
      this.loadVatPatterns(true); // Carga los patrones de IVA al inicializar el componente
    });

    // Escuchar cambios de página desde el servicio compartido
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.learningResourceFeeResponse.pageDto.currentPage = page; // Actualiza la página en la respuesta
      this.loadLearningResourcesFees(false); // Recarga los datos
    });

    this.filterParams.get('taxModel')?.valueChanges.subscribe((value) => {
      this.selectedRateModel = this.modelResponse.listRateModelDto.find((item) => item.idRateModel === Number(value)) || new RateModelDto(); // Asegura que el valor sea numérico y crea una nueva instancia correctamente
      this.loadLearningResourcesFees(true); // Llama a la función para obtener las tasas académicas
      this.selectedRowId = null;
      this.isCreate = false
    });

    this.formDiscount.get('importType')?.valueChanges.subscribe((value) => {
      value == 'I' ? this.formDiscount.get('discountPercentage')?.patchValue(0) : null
      value == 'P' ? this.formDiscount.get('fixedDiscountAmount')?.patchValue(0) : null
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  changeDescompte() {
    if (this.selectedOwnRateDiscountId == null) {
      this.formDiscount.get('fixedDiscountAmount')?.patchValue(0)
      this.formDiscount.get('discountPercentage')?.patchValue(0)
      let discount: GeneralDiscountCatalogDto[] = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })
      if (discount[0].discountFixedAmount && discount[0].discountFixedAmount > 0) {
        this.formDiscount.get('fixedDiscountAmount')?.patchValue(discount[0].discountFixedAmount)
        this.formDiscount.get('importType')?.patchValue("I")
      }
      if (discount[0].discountPercentage && discount[0].discountPercentage > 0) {
        this.formDiscount.get('discountPercentage')?.patchValue(discount[0].discountPercentage)
        this.formDiscount.get('importType')?.patchValue("P")
      }
    }
  }

  get hasLearningResources(): boolean {
    return this.learningResourceFeeResponse.listLearningResourceFeeDto && this.learningResourceFeeResponse.listLearningResourceFeeDto.length > 0;
  }

  filterParams = new FormGroup({
    taxModel: new FormControl(), // Control para el select "Tipo de tasa"

  });

  // Seleccionar o deseleccionar una fila en una tabla específica
  toggleRow(row: any): void {
    if (this.selectedRowId === row.idOwnLearningResourceRate) {
      window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
      setTimeout(() => {
        this.selectedRowId = null; // Deselecciona si ya estaba seleccionada
        this.selectedMaterialPricesRowId = null;
        this.selectedOwnRateDiscountId = null
      }, 350);
    } else {
      this.isCreate = false; // Cambia a modo de edicion
      this.selectedRowId = row.idOwnLearningResourceRate; // Selecciona la nueva fila
      this.loadLearningResourceFeeById();
      this.loadLearningResourceFeePricesById(true);
      this.loadOwnRateDiscountByRateType(row.idOwnLearningResourceRate)
      this.loadDiscounts()
      this.loadDiscountsRateModel()
      this.learningResourceForm.get('typeMaterial')?.disable()
      this.cdr.detectChanges();
      window.scrollTo(0, 600);
      //Rellenar formComponent con el obj de la fila seleccionada
    }
    console.log('ID de la fila seleccionada:', this.selectedRowId);
  }

  // Seleccionar o deseleccionar una fila en una tabla específica
  toggleRowMaterialPrices(row: any): void {
    if (this.selectedMaterialPricesRowId === row.idOwnLearningResourcePriceDetail) {
      setTimeout(() => {
        this.selectedMaterialPricesRowId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
    } else {
      if (row) {
        this.learningResourcePriceForm.patchValue({
          startDate: row.startDate,
          endDate: row.endDate,
          firstTermPayment: row.firstTermPayment,
          price: row.price,
          idVatPattern: row.vatPatternDto?.idVatPattern,
        });
        this.selectedMaterialPricesRowId = row.idOwnLearningResourcePriceDetail;
      }
      this.isCreateMaterialPrices = false; // Cambia a modo de edicion
      this.loadLearningResourceFeeById();
      this.loadLearningResourceFeePricesById(true);
      this.cdr.detectChanges();
      window.scrollTo(0, 600);
    }
    console.log('ID de la fila seleccionada:', this.selectedRowId);
  }

  toggleRowAcademicDiscount(row: any): void {
    if (this.selectedOwnRateDiscountId === row.idOwnRateDiscount) {
      setTimeout(() => {
        this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
      }, 350);
    } else {
      if (row) {
        console.log(row)
        this.formDiscount.patchValue({
          startDate: row.startDate,
          endDate: row.endDate,
          rateType: row.rateType,
          idOwnRateDiscount: row.idOwnRateDiscount,
          discountOrderNumber: row.discountOrderNumber,
          fixedDiscountAmount: row.fixedDiscountAmount,
          discountPercentage: row.discountPercentage,
          idRateModel: row.rateModelDto.codeRateModel,
          idGeneralDiscountCatalog: row.generalDiscountCatalogDto.idGeneralDiscountCatalog
        });
        row.fixedDiscountAmount > 0 ? this.formDiscount.get('importType')?.patchValue('I') : this.formDiscount.get('importType')?.patchValue('P')
        //this.formDiscount.disable()
        this.formDiscount.get('idRateModel')?.disable()
        this.isCreatedOwnRateDiscount = false; // Cambia a modo de edicion
        this.selectedOwnRateDiscount = row
        this.selectedOwnRateDiscountId = row.idOwnRateDiscount; // Asigna el ID del precio académico seleccionado
        this.formDiscount.get('idGeneralDiscountCatalog')?.disable()
      }
      this.cdr.detectChanges();
    }

  }

  newRegister() {
    this.learningResourcePriceForm.reset()
    this.isCreateMaterialPrices = true;
    this.selectedMaterialPricesRowId = null;
  }

  newAcademicDiscount() {
    this.formDiscount.reset()
    this.formDiscount.enable()
    this.selectedOwnRateDiscountId = null;
    this.isCreatedOwnRateDiscount = true;
    this.formDiscount.get('idRateModel')?.disable()
    this.formDiscount.get('idRateModel')?.patchValue(this.selectedRateModel.codeRateModel)
  }

  newModel(): void {
    this.learningResourceForm.reset(); // Reinicia el formulario
    this.learningResourceForm.get('typeMaterial')?.enable()
    this.isCreate = true; // Cambia a modo de creación
    this.isCreateMaterialPrices = this.isCreateOwnRateDiscount = false
    this.selectedRowId = this.selectedMaterialPricesRowId = this.selectedOwnRateDiscountId = null; // Deselecciona la fila actual
    this.learningResourceFee = new LearningResourceFeeDto(); // Reinicia el objeto de tasa de recursos de aprendizaje
    this.cdr.detectChanges();
    window.scrollTo(0, 600); // Desplaza la vista al inicio de la página
  }

  // Método para cancelar y reiniciar el formulario
  onCancel(): void {
    this.learningResourceForm.reset(); // Limpia los datos del formulario
    this.selectedRowId = this.selectedMaterialPricesRowId = this.selectedOwnRateDiscountId = null; // Deselecciona cualquier fila
    this.isCreate = this.isCreateMaterialPrices = this.isCreateOwnRateDiscount = false; // Cambia a modo cerrado
    this.learningResourceFee = new LearningResourceFeeDto(); // Reinicia el objeto de tasa de recursos de aprendizaje
    this.cdr.detectChanges(); // Detecta cambios para actualizar la vista
    window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
  }

  saveLearningResourceFee(): void {
    if (this.learningResourceForm.valid) {
      this.bindFormToObj(); // Llama a la función para enlazar el formulario con el objeto
      if (this.checkForNullTranslations()) {
        return; // Detiene la ejecución si hay traducciones nulas
      }

      if (this.isCreate) {
        let control: LearningResourceFeeDto[] = this.learningResourceFeeResponse.listLearningResourceFeeDto.filter(learning => { return learning.materialType == this.learningResourceFee.materialType })
        if (control.length > 0) {
          this.isError = true
          this.errorMessage = 'errorCreateLearning';
          return
        } else {
          this.learningResourceFeeService.insertLearningResourceFee(this.learningResourceFee).subscribe({
            next: (response) => {
              console.log('Recurso de aprendizaje insertado:', response);
              this.isCreated = true;
              this.isCreate = false;
              this.errorMessage = "S'ha creat correctament"
              this.selectedRowId = null
              this.loadLearningResourcesFees(true); // Recarga la lista de recursos de aprendizaje
              window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
            },
            error: (err) => {
              this.isError = true
              this.errorMessage = err.error.message; // Mensaje de error
              console.error('Error al insertar el recurso de aprendizaje:', err);
            }
          });
        }
      } else {
        this.learningResourceFeeService.updateLearningResourceFee(this.modifTranslates, this.learningResourceFee).subscribe({
          next: (response) => {
            console.log('Recurso de aprendizaje actualizado:', response);
            this.isCreated = true;
            this.isCreate = false;
            this.errorMessage = "S'ha editat correctament"
            this.loadLearningResourcesFees(true); // Recarga la lista de recursos de aprendizaje
            window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
          },
          error: (err) => {
            this.isCreated = false;
            this.isError = true
            this.errorMessage = err.error.message; // Mensaje de error
            console.error('Error al actualizar el recurso de aprendizaje:', err);
          }
        });
      }
    } else {
      this.isCreated = false;
      this.isError = true
      this.errorMessage = 'obligatorios';
    }

  }

  // Método auxiliar para verificar traducciones nulas
  private checkForNullTranslations(): boolean {
    const hasNullTranslations = this.learningResourceFee.ownLearningResourceRateTraductionDto?.some(translation =>
      !translation.description
    );

    if (hasNullTranslations) {
      console.log('Mostrando modal de error por traducciones nulas');
      this.isError = true
      this.errorMessage = this.translateService.instant('error.message.translations');
      return true; // Indica que hay traducciones nulas
    }

    return false; // No hay traducciones nulas
  }

  bindFormToObj(): void {
    if (this.learningResourceForm.valid) {
      if (!this.isCreate) {
        this.learningResourceFee.idOwnLearningResourceRate = this.selectedRowId; // Asigna el ID de la fila seleccionada
      }
      if (!this.learningResourceFee.rateModelDto) {
        this.learningResourceFee.rateModelDto = new RateModelDto(); // Asegura que rateModelDto esté inicializado
      }
      if (!this.learningResourceFee.ownLearningResourceRateTraductionDto || this.learningResourceFee.ownLearningResourceRateTraductionDto.length === 0) {
        this.learningResourceFee.ownLearningResourceRateTraductionDto = [
          { languageDto: { idLanguage: 1 }, description: undefined },
          { languageDto: { idLanguage: 2 }, description: undefined },
          { languageDto: { idLanguage: 3 }, description: undefined }
        ]; // Inicializa ownAcademicFeeTraductionDto si es undefined o vacío
      }

      this.learningResourceFee.rateModelDto.idRateModel = this.selectedRateModel.idRateModel || undefined; // Asigna el ID del modelo de tasa seleccionado
      this.learningResourceFee.ownLearningResourceRateTraductionDto.forEach((translation) => {
        if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
          if (translation.description != this.learningResourceForm.get('descriptionCast')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.description = this.learningResourceForm.get('descriptionCast')?.value ?? undefined;
        } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
          if (translation.description != this.learningResourceForm.get('descriptionCat')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.description = this.learningResourceForm.get('descriptionCat')?.value ?? undefined;
        } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
          if (translation.description != this.learningResourceForm.get('descriptionIng')?.value) {
            this.modifTranslates = true; // Marca como modificado si hay cambios en las traducciones
          }
          translation.description = this.learningResourceForm.get('descriptionIng')?.value ?? undefined;
        }
      });

      this.learningResourceFee.chargeShipping = this.learningResourceForm.get('chargeShipping')?.value || false; // Obtiene el valor del checkbox
      this.learningResourceFee.active = 'S'; // Obtiene el valor del campo activo
      this.learningResourceFee.materialType = this.learningResourceForm.get('typeMaterial')?.value || 'C'

      this.learningResourceFee.rateModelDto = this.learningResourceFee.rateModelDto || {}; // Ensure rateModelDto is initialized
      this.learningResourceFee.rateModelDto.idRateModel = this.selectedRateModel.idRateModel || undefined; // Asigna el ID del modelo de tasa seleccionado
    }
  }

  // Abrir el modal

  savePriceRecord(): void {
    if (this.learningResourcePriceForm.valid) {
      let learningResourcePriceDto = new LearningResourceFeePriceDto(); // Inicializa el objeto LearningResourceFeePriceDto
      this.createPrice = true; // Variable para determinar si se crea un nuevo precio de recurso

      if (this.selectedMaterialPricesRowId) {
        learningResourcePriceDto.idOwnLearningResourcePriceDetail = this.selectedMaterialPricesRowId; // Asigna el ID del precio de recurso seleccionado
        this.createPrice = false; // No crea un nuevo precio si ya existe uno
      }

      // Asigna los valores del formulario al objeto DTO
      learningResourcePriceDto.startDate = this.learningResourcePriceForm.get('startDate')?.value || undefined;
      learningResourcePriceDto.endDate = this.learningResourcePriceForm.get('endDate')?.value || undefined;
      learningResourcePriceDto.firstTermPayment = this.learningResourcePriceForm.get('firstTermPayment')?.value || false;
      learningResourcePriceDto.price = Number(this.learningResourcePriceForm.get('price')?.value || undefined);

      if (!learningResourcePriceDto.vatPatternDto) {
        learningResourcePriceDto.vatPatternDto = new VatPatternDto();
      }
      learningResourcePriceDto.vatPatternDto.idVatPattern = this.learningResourcePriceForm.get('idVatPattern')?.value || undefined;

      if (!learningResourcePriceDto.ownLearningResourceRateDto) {
        learningResourcePriceDto.ownLearningResourceRateDto = new LearningResourceFeeDto();
      }
      learningResourcePriceDto.ownLearningResourceRateDto.idOwnLearningResourceRate = this.selectedRowId;

      if (this.createPrice || this.isClone) {
        // Inserta un nuevo precio
        this.learningResourceFeePriceService.insertLearningResourceFeePrice(learningResourcePriceDto).subscribe({
          next: (response) => {
            console.log('Precio de recurso de aprendizaje creado:', response);
            this.isCreatedMaterialPrices = true
            this.isCreateMaterialPrices = false
            this.isErrorMaterialPrices = false
            this.errorMessage = "S'ha creat correctament"
            this.isClone = false

            this.loadLearningResourceFeePricesById(true); // Actualiza la lista de precios
          },
          error: (err) => {
            console.error('Error al crear el precio de recurso de aprendizaje:', err);
            this.isCreatedMaterialPrices = false
            this.isErrorMaterialPrices = true
            this.errorMessage = err.error.message;
          }
        });
      } else {
        // Actualiza un precio existente
        this.learningResourceFeePriceService.updateLearningResourceFeePrice(learningResourcePriceDto).subscribe({
          next: (response) => {
            console.log('Precio de recurso de aprendizaje actualizado:', response);
            this.isCreatedMaterialPrices = true
            this.isCreateMaterialPrices = false
            this.isErrorMaterialPrices = false
            this.errorMessage = "S'ha editat correctament"

            this.loadLearningResourceFeePricesById(true); // Actualiza la lista de precios
          },
          error: (err) => {
            console.error('Error al actualizar el precio de recurso de aprendizaje:', err);
            this.isCreatedMaterialPrices = false
            this.isErrorMaterialPrices = true
            this.errorMessage = err.error.message;

          }
        });
      }
      console.log('Datos guardados / modificados:', learningResourcePriceDto);
    } else {
      this.isCreatedMaterialPrices = false
      this.isErrorMaterialPrices = true
      this.errorMessage = 'obligatorios';
    }
  }

  saveOwnRateDiscount() {
    if (this.controlDates(this.formDiscount.get('startDate')?.value, this.formDiscount.get('endDate')?.value)) {
      this.isErrorOwnRateDiscount = false
      this.isCreateOwnRateDiscount = false;
      this.isErrorOwnRateDiscount = true
      this.isCreateOwnRateDiscount = false;
      this.errorMessage = 'fechas';
      return
    }
    if (this.selectedOwnRateDiscountId) {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.idOwnRateDiscount != this.selectedOwnRateDiscountId && resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    else {
      this.message = this.ownRateDiscountResponse.IdOwnRateDiscountDto.filter(resp => { return resp.discountOrderNumber == this.formDiscount.get('discountOrderNumber')?.value })
    }
    if (this.message.length > 0) {
      return
    }
    this.formDiscount.get('rateType')?.patchValue('M')
    if (this.formDiscount.valid) {


      this.buildOwnRateDiscount()
      if (this.selectedOwnRateDiscountId) {
        this.discountServices.updateOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: () => {
            this.isCreateOwnRateDiscount = true;
            this.errorMessage = "S'ha editat correctament"
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err: { error: { message: string; }; }) => {
            this.isErrorOwnRateDiscount = true
            this.errorMessage = err.error.message
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
            console.error('Error al actualizar la tasa académica:', err);
          }
        });
      } else {
        this.discountServices.insertOwnRateDiscount(this.selectedOwnRateDiscount).subscribe({
          next: () => {
            this.isCreateOwnRateDiscount = true;
            this.errorMessage = "S'ha creat correctament"
            this.selectedOwnRateDiscountId = null; // Deselecciona si ya estaba seleccionada
            this.isCreatedOwnRateDiscount = false
            this.formDiscount.reset(); // Limpia los datos del formulario
            this.loadOwnRateDiscountByRateType(this.selectedRowId); // Actualiza la lista después de guardar
          }
          , error: (err: { error: { message: string; }; }) => {
            this.isCreateOwnRateDiscount = false;
            this.isErrorOwnRateDiscount = true
            this.errorMessage = err.error.message
            console.error('Error al crear la tasa académica:', err);
          }
        });
      }
    } else {
      this.isCreateOwnRateDiscount = false;
      this.isErrorOwnRateDiscount = true
      this.errorMessage = 'obligatorios'
    }
  }

  buildOwnRateDiscount() {
    this.selectedOwnRateDiscount.generalDiscountCatalogDto = new GeneralDiscountCatalogDto()
    this.selectedOwnRateDiscount.rateModelDto = new RateModelDto()

    this.selectedOwnRateDiscount.discountOrderNumber = this.formDiscount.get('discountOrderNumber')?.value || undefined
    this.selectedOwnRateDiscount.discountPercentage = this.formDiscount.get('discountPercentage')?.value
    this.selectedOwnRateDiscount.endDate = this.formDiscount.get('endDate')?.value || ''
    this.selectedOwnRateDiscount.startDate = this.formDiscount.get('startDate')?.value || ''
    this.selectedOwnRateDiscount.fixedDiscountAmount = this.formDiscount.get('fixedDiscountAmount')?.value
    this.selectedOwnRateDiscount.rateType = "M"
    this.selectedOwnRateDiscount.rateId = this.selectedRowId
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.idGeneralDiscountCatalog = this.formDiscount.get('idGeneralDiscountCatalog')?.value : null
    this.selectedOwnRateDiscount.generalDiscountCatalogDto ? this.selectedOwnRateDiscount.generalDiscountCatalogDto.discountCode = this.discountReponse.GeneralDiscountCatalogDto.filter(disc => { return disc.idGeneralDiscountCatalog == this.formDiscount.get('idGeneralDiscountCatalog')?.value })[0].discountCode : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.idRateModel = this.selectedRateModel.idRateModel : null
    this.selectedOwnRateDiscount.rateModelDto ? this.selectedOwnRateDiscount.rateModelDto.codeRateModel = this.selectedRateModel.codeRateModel : null

    !this.selectedOwnRateDiscountId ? this.selectedOwnRateDiscount.idOwnRateDiscount = undefined : null
  }

  loadDiscounts() {
    this.discountServices.getListGeneralDiscountCatalog(this.discountRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.discountReponse.GeneralDiscountCatalogDto = response.listGeneralDiscountCatalog.map((rt: any) => {
            return {
              ...rt,
              generalDiscountCatalogTraductionDto: rt.generalDiscountCatalogTraductionDto.filter((t: any) => t.languageDto.code.includes(this.translateService.currentLang || 'es')),
            };
          });
          response.pageDto !== undefined ? this.discountReponse.pageDto = response.pageDto : null
        }
        console.log(this.discountReponse.GeneralDiscountCatalogDto)
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  loadDiscountsRateModel() {
    this.discountServices.getListDiscountRateModelCatalog(this.discountRequest.pageRequest, this.selectedRateModel.idRateModel).subscribe({
      next: response => {
        if (response != null) {
          this.discountRateModelResponse.discountRateModelCatalogDto = response.listDiscountRateModelCatalog.filter((discount: { rateModelDto: { idRateModel: number | null; }; }) => { return discount.rateModelDto.idRateModel == this.filterParams.get('taxModel')?.value })
          this.discountRateModelResponse.discountRateModelCatalogDto = sortByDiscountCode(this.discountRateModelResponse.discountRateModelCatalogDto)

        }
      }, error: (error: any) => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  getDiscountDescription(id?: any): string {
    let descr;
    let discount = this.discountReponse.GeneralDiscountCatalogDto.filter(list => { return list.idGeneralDiscountCatalog == id })
    if (discount.length === 0) {
      return '';
    }
    discount[0].generalDiscountCatalogTraductionDto ? descr = discount[0].generalDiscountCatalogTraductionDto[0].discountDescription : null;
    return descr || ''
  }

  getLearningResourceDescription(): string {
    console.log(this.selectedRowId)

    return this.learningResourceForm.get('descriptionCast')?.value || this.learningResourceForm.get('typeMaterial')?.value || ''
  }

  loadOwnRateDiscountByRateType(id: number) {
    this.discountServices.loadOwnRateDiscountByRateType(this.ownRateDiscountRequest.pageRequest, id, "M").subscribe(list => {
      this.ownRateDiscountResponse.IdOwnRateDiscountDto = list.listOwnRateDiscount
    })
  }

  loadLearningResourcesFees(init: boolean): void {
    if (!init) {
      this.learningResourceFeeRequest.pageRequest.page = this.learningResourceFeeResponse.pageDto.currentPage;
    }

    this.learningResourceFeeService.getLearningResourceFeesByRateModel(this.learningResourceFeeRequest.pageRequest,
      this.selectedRateModel.codeRateModel).subscribe({
        next: response => {
          if (response != null) {
            this.learningResourceFeeResponse.listLearningResourceFeeDto = response.listOwnLearningResourcesRateDto.map((rt: any) => ({
              ...rt,
              ownLearningResourceRateTraductionDto: rt.ownLearningResourceRateTraductionDto.filter((t: any) =>
                t.languageDto.code.includes(this.currentLanguage)
              ),
            }));
            if (!response.pageDto) {
              this.learningResourceFeeResponse.pageDto = response.pageDto;
            }
          }
          console.log(this.learningResourceFeeResponse.listLearningResourceFeeDto)
        },
        error: (err) => {
          console.error('Error al obtener las tasas académicas:', err);
        },
      });
  }

  loadRateModels(init: boolean): void {
    if (!init) {
      this.modelRequest.pageRequest.page = this.modelResponse.pageDto.currentPage;
    }
    this.modelRequest.pageRequest.sizePage = 1000; // Carga un número grande de modelos de tasa para evitar la paginación en el select

    this.taxesService.getListTaxesAll(this.modelRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          // Asigna la lista de modelos a la propiedad listModels para mostrarlos en la tabla
          this.modelResponse.listRateModelDto = response.listRateModel.map((rt: any) => {
            return {
              ...rt,
              rateModelTraductionDto: rt.rateModelTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          this.modelResponse.listRateModelDto = this.modelResponse.listRateModelDto.filter(list => { return list.learningResourcesRates == true })

          if (response.pageDto !== undefined) {
            this.modelResponse.pageDto = response.pageDto;
          }
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
        this.modelResponse.listRateModelDto = []; // Asigna una lista vacía en caso de error
      }
    });
  }

  loadVatPatterns(init: boolean): void {
    if (!init) {
      this.vatPatternRequest.pageRequest.page = this.vatPatternResponse.pageDto.currentPage;
    }

    this.vatPatternService.getListVatPattern(this.vatPatternRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.listVatPattern = response.listVatPattern.map((rt: any) => {
            return {
              ...rt,
              vatPatternTraductionDto: rt.vatPatternTraductionDto.filter((t: any) => t.languageDto.code.includes(this.currentLanguage)),
            };
          });
          if (response.pageDto !== undefined) {
            this.vatPatternResponse.pageDto = response.pageDto;
          }
        }
      },
      error: (err) => {
        console.error('Error al obtener los patrones de IVA:', err);
      }
    });
  }

  // Método para filtar los precios vigentes de un recurso de aprendizaje
  filterPricesByVigency(event: Event): void {
    const vigente = (event.target as HTMLInputElement).checked; // Obtiene el estado del checkbox desde el evento
    // Filtramos los precios vigentes (Aquellos que tienen fecha de inicio <= hoy y fecha de fin >= hoy)
    const today = new Date(); // Fecha actual
    this.learningResourceFeePriceResponse.listLearningResourceFeePriceDto =
      this.learningResourceFeePriceResponse.listLearningResourceFeePriceDto.filter(({ startDate, endDate }) => {
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;
        return !vigente || (start && end && start <= today && end >= today);
      });
  }

  loadLearningResourceFeePricesById(init: boolean): void {
    if (!init) {
      this.learningResourceFeePriceRequest.pageRequest.page = this.learningResourceFeePriceResponse.pageDto.currentPage;
    }
    this.learningResourceFeePriceService.getByLearningResourceId(this.learningResourceFeePriceRequest.pageRequest, this.selectedRowId).subscribe({
      next: response => {
        if (response != null) {
          this.learningResourceFeePriceResponse.listLearningResourceFeePriceDto = response.listLearningResourcePriceDetail;

          if (!response.pageDto) {
            this.learningResourceFeePriceResponse.pageDto = response.pageDto;
          }
        }
      },
      error: (err) => {
        console.error('Error al obtener el precio académico:', err);
      }
    });
  }

  loadLearningResourceFeeById(): void {
    this.learningResourceFeeService.getLearningResourceFeeById(this.selectedRowId).subscribe({
      next: (response) => {
        this.learningResourceFee = response;
        const catalanIndex = this.learningResourceFee?.ownLearningResourceRateTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "ca"
        ) ?? -1;

        const spanishIndex = this.learningResourceFee?.ownLearningResourceRateTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "es"
        ) ?? -1;

        const englishIndex = this.learningResourceFee?.ownLearningResourceRateTraductionDto?.findIndex(
          (translation) => translation.languageDto?.code === "en"
        ) ?? -1;

        const selectedIndex = this.currentLanguage === 'ca' ? catalanIndex :
          this.currentLanguage === 'es' ? spanishIndex :
            this.currentLanguage === 'en' ? englishIndex : -1;

        // Realiza el patchValue para actualizar el formulario

        this.learningResourceForm.patchValue({
          typeMaterial: selectedIndex >= 0 ? this.learningResourceFee?.materialType || '' : '',
          descriptionCast: spanishIndex >= 0 ? this.learningResourceFee?.ownLearningResourceRateTraductionDto?.[spanishIndex]?.description || '' : '',
          descriptionCat: catalanIndex >= 0 ? this.learningResourceFee?.ownLearningResourceRateTraductionDto?.[catalanIndex]?.description || '' : '',
          descriptionIng: englishIndex >= 0 ? this.learningResourceFee?.ownLearningResourceRateTraductionDto?.[englishIndex]?.description || '' : '',
          chargeShipping: this.learningResourceFee?.chargeShipping || false,
        });
      },
      error: (err) => {
        console.error('Error al obtener el recurso de aprendizaje:', err);
      }
    });
  }

  clone() {
    this.isClone = true;
    this.isCreatedMaterialPrices = true;
    this.selectedMaterialPricesRowId = null;
    this.errorMessage = "S'ha clonat correctament"
  }

  controlDates(startDate: any, dateEnd: any): boolean {
    if (!dateEnd) { return false }
    return (new Date(startDate) > new Date(dateEnd)) ? true : false;
  }

  isDiscountValid(discountCode: any): boolean {
    console.log(this.ownRateDiscountResponse.IdOwnRateDiscountDto)
    const discount = this.ownRateDiscountResponse.IdOwnRateDiscountDto.find(disc => disc.generalDiscountCatalogDto?.discountCode === discountCode);
    console.log(discount)
    return discount == undefined;
  }
}
function sortByDiscountCode(array: any[]) {
  return array.sort((a: { generalDiscountCatalogDto: { discountCode: string; }; }, b: { generalDiscountCatalogDto: { discountCode: any; }; }) =>
    a.generalDiscountCatalogDto.discountCode.localeCompare(b.generalDiscountCatalogDto.discountCode)
  );
}